import { defineStore } from "pinia";

const initialDetails = {
  saleDetails: {
    Business: {
      bhfId: "",
      branch: "",
      id: null,
      pin: "",
      taxprNm: "",
    },
    PRINT: "",
    businessId: null,
    cfmDt: "",
    checksum: null,
    cnclDt: null,
    cnclReqDt: null,
    createdAt: "",
    curRcptNo: "",
    custNm: null,
    custTin: "",
    deletedAt: null,
    etimsobj: "{}",
    id: null,
    intrlData: "",
    invcNo: null,
    items: [],
    long_url: null,
    orgInvcNo: null,
    pmtTyCd: "",
    prchrAcptcYn: "",
    qrurl: "",
    rcptSign: "",
    rcptTyCd: "",
    receipt: null,
    remark: "",
    resultDt: null,
    retries: 0,
    rfdDt: null,
    rfdRsnCd: null,
    saleReceiptId: null,
    salesDt: "",
    salesSttsCd: "",
    salesTyCd: "",
    sdcDateTime: "",
    short_id: null,
    short_url: null,
    status: "",
    stockRlsDt: "",
    stockobj: "{}",
    taxAmtA: "0",
    taxAmtB: "0",
    taxAmtC: "0",
    taxAmtD: "0",
    taxAmtE: "0",
    taxRtA: "0",
    taxRtB: "0",
    taxRtC: "0",
    taxRtD: "0",
    taxRtE: "0",
    taxblAmtA: "0",
    taxblAmtB: "0",
    taxblAmtC: "0",
    taxblAmtD: "0",
    taxblAmtE: "0",
    token: "",
    tokenreal: "",
    totAmt: "0",
    totItemCnt: 0,
    totRcptNo: "",
    totTaxAmt: "0",
    totTaxblAmt: "0",
    trdInvcNo: null,
    updatedAt: "",
    userId: null,
  },
  sales: [],
  business: {
    bhfId: "",
    bhfNm: "",
    bhfOpenDt: "",
    branch: "",
    bsnsActv: "",
    cmcKey: "",
    createdAt: "",
    deletedAt: null,
    dstrtNm: "",
    dvcId: "",
    email: "",
    hqYn: null,
    id: null,
    locDesc: null,
    mgrEmail: null,
    mgrNm: "",
    mgrTelNo: "",
    mrcNo: "",
    name: "",
    phone: "",
    pin: "",
    prvncNm: "",
    sctrNm: "",
    sdcId: "",
    shuriHqBranchAccount: "",
    shuriHqBranchId: "",
    shuriId: "",
    source: "",
    sourceId: null,
    status: "",
    taxprNm: "",
    updatedAt: "",
  },
};

export const useMakeSaleStore = defineStore({
  id: "getSale",
  state: () => ({
    saleDetails: initialDetails.saleDetails,
    sales: initialDetails.sales,
    business: initialDetails.business,
  }),
  getters: {
    getSaleDetails: (state) => state.saleDetails,
    getSales: (state) => state.sales,
    getBusiness: (state) => state.business,
  },
  actions: {
    fetchSaleId(invc) {
      const sale = this.sales.find((sale) => sale.invcNo === invc);
      this.saleDetails = sale;
    },
    setBusiness(business) {
      this.business = business;
    },
    setSaleDetails(sales) {
      this.sales = sales;
    },
    clearSaleStore() {
      this.saleDetails = initialDetails.saleDetails;
      this.sales = initialDetails.sales;
      this.business = initialDetails.business;
      sessionStorage.removeItem("getSale");
    },
  },
  persist: {
    storage: sessionStorage,
    paths: "pinia-getSale",
  },
});
